import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const SegmentationListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Criteria', value: 'criteria' },
    { label: 'Description', value: 'description' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/reporting/segmentation/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['segmentation']} />;
};

export default SegmentationListDetails;